import request from './request.js'

export function userLogin(name, password) {
  return request.post("/api/v1/user/login",  {name: name, password: password});
}

export function getRegions(data) {
  return request.get("/api/v1/common/regions", {params: data});
}

export function getUserById(data) {
  return request.get("/api/v1/user/getById", {params: data});
}

export function getTeamOwnerById(data) {
  return request.get("/api/v1/user/teamOwner", {params: data});
}

export function userQuery(data) {
  return request.get("/api/v1/user/query", {params: data});
}

export function userIncomes(data) {
  return request.get("/api/v1/user/incomes", {params: data});
}

export function userCashOutHistories(data) {
  return request.get("/api/v1/user/cash_out_histories", {params: data});
}

export function userCards(data) {
  return request.get("/api/v1/user/cards", {params: data});
}

export function userMaintains(data) {
  return request.get("/api/v1/user/maintains", {params: data});
}

export function userMaintainForceFail(data) {
  return request.post("/api/v1/user/maintain/forceFail/" + data.maintainId, {});
}

export function activateVip(data) {
  return request.post("/api/v1/user/activateVip", data);
}

export function updateCardFreeTimes(params) {
  return request.post("/api/v1/user/updateCardFreeTimes", '', {params})
}

export function updateBalance(data) {
  return request.post("/api/v1/user/updateBalance", data);
}

export function updateRecommendations(data) {
  return request.post("/api/v1/user/updateRecommendationRelationships", data);
}

export function updateUserBasicInfo(data) {
  return request.post("/api/v1/user/updateBasicInfo", data);
}

export function joinTeam(data) {
  return request.post("/api/v1/user/joinTeam", data);
}

export function userPromotions(data) {
  return request.get("/api/v1/user/promotions", {params: data});
}

/**  provider related API **/
export function getProviderByCustomer(data) {
  return request.get("/api/v1/provider/getByCustomer", {params: data});
}

export function getProviderOwner(data) {
  return request.get("/api/v1/provider/getOwner", {params: data});
}

export function providerQuery(data) {
  return request.get("/api/v1/provider/query", {params: data});
}

export function getProviderById(data) {
  return request.get("/api/v1/provider/getById", {params: data});
}

export function getProviderImages(data) {
  return request.get("/api/v1/provider/getImages", {params: data});
}

export function providerAudit(data) {
  return request.post("/api/v1/provider/audit", data);
}

export function providerOffline(data) {
  return request.post("/api/v1/provider/offline", data);
}

export function providerUpdateBasicInfo(data) {
  return request.post("/api/v1/provider/update", data);
}

export function providerIncomes(data) {
  return request.get("/api/v1/provider/incomes", {params: data});
}

export function providerMaintains(data) {
  return request.get("/api/v1/provider/maintains", {params: data});
}

export function providerCostInfo(data) {
  return request.get("/api/v1/provider/costInfo", {params: data});
}

export function updateCostInfo(data) {
  return request.post("/api/v1/provider/updateCostInfo", data);
}

export function providerOilStock(data) {
  return request.get("/api/v1/provider/oilStock", {params: data});
}

export function providerOilStockUpdateHistories(data) {
  return request.get("/api/v1/provider/getStockUpdateHistories", {params: data});
}

export function providerOilTypes(data) {
  return request.get("/api/v1/provider/oilTypes", {params: data});
}

export function providerUpdateStocks(data) {
  return request.post("/api/v1/provider/updateStocks", data);
}

export function providerStockFlow(data) {
  return request.get("/api/v1/provider/getStockFlow", {params: data});
}

export function providerBalanceUpdateHistory(data) {
  return request.get("/api/v1/provider/getBalanceUpdateHistory", {params: data});
}

export function providerTeamInfo(data) {
  return request.get("/api/v1/provider/getTeamInfo", {params: data});
}

export function providerRecommendedProviders(data) {
  return request.get("/api/v1/provider/getRecommendedProviders", {params: data});
}

export function providerUpdateRecommender(data) {
  return request.post("/api/v1/provider/updateRecommender", data);
}

export function providerAllOilRequests(data) {
  return request.get("/api/v1/provider/getAllOilRequests", {params: data});
}

export function providerOilRequestAudit(data) {
  return request.post("/api/v1/provider/auditOilRequest", data);
}

export function providerProcessManagedRegion(data) {
  return request.post("/api/v1/provider/processManagedRegion", data);
}

export function providerGetAllManagedRegions(data) {
  return request.get("/api/v1/provider/getAllManagedRegions", {params: data});
}

/** Pay related API */
export function payQuery(data) {
  return request.get("/api/v1/pay/query", {params: data});
}

export function payDetails(data) {
  return request.get("/api/v1/pay/details", {params: data});
}

export function resetPayStatus(data) {
  return request.post("/api/v1/pay/reset/" + data.payId, {});
}

/** Notification API */
export function getAllNotifications(data) {
  return request.get("/api/v1/notification/getAll", {params: data});
}

export function publishNotification(data) {
  return request.post("/api/v1/notification/publish", data);
}

/** Coupon API */
export function createCouponBatch(data) {
  return request.post("/api/v1/coupon/createBatch", data);
}

export function getAllCouponBatch(data) {
  return request.get("/api/v1/coupon/getAllBatch", {params: data});
}

export function downloadCoupons(data) {
  return request.get("/api/v1/coupon/download", {
    params: data,
    responseType: 'blob'
  });
}

/** Cashback API */
export function cashbackQuery(data) {
  return request.get("/api/v1/cashback/list", {params: data});
}

/** Veteran API */
export function queryVeteran(data) {
  return request.post("/api/v1/veteran/query", data);
}

export function auditVeteran(data) {
  return request.post("/api/v1/veteran/audit", null,{params: data});
}



// WEBPACK FOOTER //
// ./src/js/api.js